<template>
<div>
  <div v-show="mustShowInputComponent || isMobile">
    <div v-show="passeioTipo !== 'intervalo_dias'">
      <div
        v-if="!isMobile"
        style="font-size: 14px; margin-bottom: 10px;">
        <i class="fa-regular fa-clock" />&nbsp;&nbsp;
        <strong>{{ titulo }}</strong>
      </div>
      <div
        v-if="horarios.length > 0"
        :class="{
          'container-horarios': !isMobile,
          'container-horarios-mobile': isMobile
        }">
        <div
          v-for="hora in horarios"
          :key="hora.id"
          class="item-container">
          <div
            :class="{
              'item': true,
              'item-disabled': getQuantidadeVagas(hora) <= 0 || getQuantidadeVagasDisponiveis(hora) < 0,
            }"
            :style="{
              'background-color': hora.id === value ? primaryColor : 'white',
              'color': hora.id === value ? 'white' : '#2A2A2A',
            }"
            @click="selectHora(hora.id)">
            <strong v-if="isMobile">{{ hora.label }}</strong>
            <span v-else>{{ hora.label }}</span>
          </div>
          <div v-if="showRemainingVacancies">
            <small
              v-if="getQuantidadeVagas(hora) == 1"
              :style="{color: getCorQuantidade(hora)}">Resta {{ getQuantidadeVagas(hora) }} vaga</small>
            <small
              v-else-if="getQuantidadeVagas(hora) > 0"
              :style="{color: getCorQuantidade(hora)}">Restam {{ getQuantidadeVagas(hora) }} vagas</small>
            <small
              v-else
              :style="{color: getCorQuantidade(hora)}">Esgotado</small>
          </div>
        </div>
      </div>
      <div
        v-else
        style="text-align: center;">
        <i>Nenhuma horário disponível</i>
      </div>
    </div>
    <div
      v-show="passeioTipo === 'intervalo_dias' && isMobile"
      style="text-align: center;">
      <i>Atividade para o dia todo</i>
    </div>
  </div>
</div>
</template>

<script>

export default {
    components: {},
    props: {
        value: {
            validator: (v) => typeof v === 'string' || typeof v === 'number' || v == null,
            default: () => null,
            required: false
        },
        horarios: {
            type: Array,
            default: () => [],
            required: true
        },
        selectedQuantities: {
            type: Array,
            default: () => [],
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        passeioTipo: {
            type: String,
            default: () => 'fixo',
            required: true
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        },
        showRemainingVacancies: {
            type: Boolean,
            default: () => false,
            required: true
        },
        tituloAtividade: {
            type: String,
            default: () => 'Atividade',
            required: false
        },
        generoTituloAtividade: {
            type: String,
            default: () => 'f',
            required: false
        }
    },
    emits: ['input', 'hora-changed', 'max-vagas-changed'],
    data() {
        return {};
    },
    computed: {
        titulo() {
            if(this.horarios.length > 1) {
                return 'SELECIONE O HORÁRIO';
            }

            const titulo = this.tituloAtividade.toUpperCase();
            const genero = this.generoTituloAtividade;
            return 'HORÁRIO '
                    + (genero === 'm' ? 'DO ' : 'DA ')
                    + titulo;
        },
        mustShowInputComponent() {
            return this.$props.passeioTipo != 'livre';
        }
    },
    watch: {
        horarios() {
            if(
                (this.$props.passeioTipo == 'intervalo_dias' && this.horarios.length > 0) ||
                (this.horarios.length === 1 && this.getQuantidadeVagas(this.horarios[0]) > 0)
            ) {
                this.selectHora(this.horarios[0].id);
            } else {
                this.selectHora(null);
            }

            let maxVagas = 0;
            this.horarios.forEach(horario => {
                const vagas = this.getQuantidadeVagas(horario);
                if(vagas > maxVagas) {
                    maxVagas = vagas;
                }
            });
            this.$emit('max-vagas-changed', maxVagas);
        },
        selectedQuantities() {
            if(!this.$props.value) {
                return;
            }
            for (let i = 0; i < this.$props.horarios.length; i++) {
                const horario = this.$props.horarios[i];
                if(horario.id == this.$props.value) {
                    const vagas = this.getQuantidadeVagasDisponiveis(horario);
                    if(vagas < 0) {
                        this.selectHora(null);
                    }
                    break;
                }
            }
        }
    },
    methods: {
        selectHora(id) {
            this.$emit('input', id);
            if(!id) {
                this.$emit('hora-changed', null);
                return;
            }
            
            for (let i = 0; i < this.$props.horarios.length; i++) {
                const horario = this.$props.horarios[i];
                if(horario.id == id) {
                    this.$emit('hora-changed', JSON.parse(JSON.stringify(horario)));
                    break;
                }
            }
        },
        getQuantidadeVagas(itemHorario) {
            return parseInt(itemHorario.quantidade) - parseInt(itemHorario.count);
        },
        getQuantidadeVagasDisponiveis(itemHorario) {
            var disponiveis = parseInt(itemHorario.quantidade) - parseInt(itemHorario.count);
            this.$props.selectedQuantities.forEach(faixa => {
                disponiveis -= faixa.quantidade;
            });
            return disponiveis;
        },
        getCorQuantidade(itemHorario) {
            const hora = this.getQuantidadeVagas(itemHorario);
            if(hora >= 5) {
                return '#21A2E5';
            }
            if(hora > 0) {
                return '#E8A114';
            }
            return '#DF6868';
        }
    }
};
</script>

<style scoped>
.container-horarios {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: flex-start;
    flex-wrap: wrap;
}
.container-horarios .item-container {
    width: 32%;
    margin-right: 1%;
    margin-bottom: 15px;
    text-align: center;
}
.container-horarios .item {
    border: 1px solid #707070;
    text-align: center;
    color: #2A2A2A;
    border-radius: 4px;
    cursor: pointer;
}
.container-horarios .item-disabled {
    pointer-events: none;
    cursor: default;
    border-color: #A0A0A0 !important;
    color: #A0A0A0 !important;
}

.container-horarios-mobile {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}
.container-horarios-mobile .item-container {
    width: 100%;
    margin-bottom: 15px;
    text-align: center;
}
.container-horarios-mobile .item {
    border: 1px solid #707070;
    text-align: center;
    color: #2A2A2A;
    border-radius: 4px;
    cursor: pointer;
    padding-top: 10px;
    padding-bottom: 10px;
}
.container-horarios-mobile .item-disabled {
    pointer-events: none;
    cursor: default;
    border-color: #A0A0A0 !important;
    color: #A0A0A0 !important;
}
</style>
